import {
  pinterest,
  ga,
  taboola,
  facebook,
  outbrain,
  avocet,
} from 'js/analytics/adapters'

export const trackPageView = () => {
  ga.page({
    url: document.location.href,
    pathname: document.location.pathname,
    title: document.title,
  })
  pinterest.page()
  taboola.page()
  facebook.page()
  outbrain.page()
  avocet.page()
}
